import { TAppState } from '../../types/appState';
import { currentOpenChatSelector } from '../currentOpenChatSelector';

export const chatImagesStatusSelector = (state: TAppState) => {
  const chat = currentOpenChatSelector(state);

  return chat?.images?.status || null;
};
